import { jwtDecode as namedJwtDecode } from 'jwt-decode';
import defaultJwtDecode from 'jwt-decode';
import config from '../config';
import { requestAnalyticSetUp } from './analytics';

export const LOGIN_RESET = 'LOGIN_RESET';
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const SET_UNAUTHORIZED_MESSAGE_VISIBLE = 'SET_UNAUTHORIZED_MESSAGE_VISIBLE';

const decode = (token) => {
  try {
    if (typeof namedJwtDecode === 'function') return namedJwtDecode(token);
    return defaultJwtDecode(token);
  } catch (e) {
    return null;
  }
};

function requestLogin() { return { type: LOGIN_REQUEST }; }
function receiveLogin(token) { return { type: LOGIN_SUCCESS, token }; }
function loginError(err) { return { type: LOGIN_FAILURE, err }; }

function handleErrors(res) {
  if (!res.ok) throw Error(`${res.status} ${res.statusText}`);
  return res;
}

export function resetLogin() { return { type: LOGIN_RESET }; }

export function loginAccount(creds) {
  return dispatch => {
    dispatch(requestLogin());
    
    return fetch(`${config.api.baseURL}/login`, {
      method: 'POST',
      body: JSON.stringify(creds),
      headers: { 'Content-Type': 'application/json' }
    })
      .then(handleErrors)
      .then(res => {
        return res.json();
      })
      .then(json => {
        if (!json || !json.token) throw new Error('InvalidServerResponse');
        
        const decoded = decode(json.token);
        
        if (!decoded) {
          throw new Error('InvalidTokenFormat'); 
        }
        
        if (decoded.analyticsId) {
          dispatch(requestAnalyticSetUp(decoded.analyticsId));
        }
        
        dispatch(receiveLogin(json.token));
      })
      .catch(err => {
        const errorMessage = err.message === 'InvalidTokenFormat' ? err.message : (err.name || 'Error');
        dispatch(loginError(errorMessage));
      });
  };
}
